import { ButtonEmphases } from '@thg-commerce/gravity-elements'
import { CarouselThemeInterface } from '@thg-commerce/gravity-patterns/Carousel/theme'
import { TextStyling } from '@thg-commerce/gravity-theme/typography/typography'

export interface ImageCardSetThemeInterface {
  carousel: CarouselThemeInterface
  title: {
    font: TextStyling
  }
  subtitle: {
    font: TextStyling
  }
  card: {
    title: {
      font: TextStyling
    }
    subtitle: {
      font: TextStyling
    }
    cta: {
      emphasis: ButtonEmphases
    }
  }
}

export const IMAGE_CARD_SET_DEFAULT_THEME: ImageCardSetThemeInterface = {
  carousel: {
    indicatorStyle: 'hidden',
  },
  title: {
    font: {
      entry: 'large1',
      style: 'alternate',
      textDecoration: 'none',
      transform: 'none',
      textColor: '#333333',
    },
  },
  subtitle: {
    font: {
      entry: 'bodyText',
      style: 'default',
      textDecoration: 'none',
      transform: 'none',
      textColor: '#333333',
    },
  },
  card: {
    title: {
      font: {
        entry: 'medium1',
        style: 'alternate',
        textDecoration: 'none',
        transform: 'none',
        textColor: '#333333',
      },
    },
    subtitle: {
      font: {
        entry: 'bodyText',
        style: 'default',
        textDecoration: 'none',
        transform: 'none',
        textColor: '#333333',
      },
    },
    cta: {
      emphasis: 'medium',
    },
  },
}
